import services from 'services/services';
import * as types from '../../types';

// Import helpers
import { checkFetchErrors } from '../../helpers_actions/convert_helpers';

// ******************** FETCH PROMOTION_OUT_PRODUCTS LIST ********************
export const fetchPromotionOutProductsList = (id) => async (dispatch) => {
	try {
		// Dispatch a loading action
		dispatch({
			type: types.FETCH_PROMOTION_OUT_PRODUCTS_LIST_LOADING,
			payload: true
		});

		const { data } = await services.get(
			`/promotions/${id}/products/out?static=1`
		);

		// Dispatch an action with data
		dispatch({
			type: types.FETCH_PROMOTION_OUT_PRODUCTS_LIST_SUCCESS,
			payload: data
		});
	} catch (error) {
		dispatch({
			type: types.FETCH_PROMOTION_OUT_PRODUCTS_LIST_ERROR,
			payload: checkFetchErrors(error)
		});
	}
};
